<template>
  <div class="section section_fixed">
    <div class="main_container main_container_fixed">
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6"><img src="@/assets/images/Group-11560.svg" loading="lazy" width="247" alt="" class="image-4">
          <h1 class="heading-3" v-html="$t('SADLY_CANNOT_INSURE_PLEASE_CALL')"></h1>
        </div>{}
        <div class="column-16 w-col w-col-3"></div>
      </div>
      <router-link class="main_button w-button" to="/contact">{{$t('CALL_ME')}}</router-link>
    </div>
  </div>
</template>

<script>
export default {

};
</script>
